import CompLayout from "@/pcomponents/comp/layout/layout";
import DailyPrescribeHistoryArea from "@/pages/comp/edu/daily_prescribe/common/history";

function DailyPrescribeHistoryPage(){

  return (
    <CompLayout isConTitle={false} >
      <DailyPrescribeHistoryArea></DailyPrescribeHistoryArea>
    </CompLayout>
  );
};
export default DailyPrescribeHistoryPage;